export default __webpack_public_path__ + "static/media/saint-malo4.bfd3599f.jpg";